import { PropTypes, React } from 'imports';
import { FormattedResource } from '..';
import TextInput from '../TextInput/TextInput';
import { roundTo } from 'utils';
import './NumberInput.less';

export default class NumberInput extends React.Component {
    static get propTypes() {
        return {
            value: PropTypes.number,
            placeholder: FormattedResource.resourcePropType,
            icon: PropTypes.string,
            debounce: PropTypes.number,
            className: PropTypes.string,
            inline: PropTypes.bool,
            multiline: PropTypes.bool,
            autofocus: PropTypes.bool,
            clearable: PropTypes.bool,
            onFocus: PropTypes.func,
            onChange: PropTypes.func,
            onCancel: PropTypes.func,
            onSubmit: PropTypes.func,
            onBlur: PropTypes.func,
            onClearClick: PropTypes.func,
            validationMethod: PropTypes.func,
            disabled: PropTypes.bool,
            minimumFractionDigits: PropTypes.number,
            maximumFractionDigits: PropTypes.number,
            percentage: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            debounce: 800,
            disabled: false,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            value: 0
        };
    }

    // we need to keep the latest state of the value right after underlying TextInput's onChange and before the value goes out to event handler and back with props
    // setState doesn't guarantee synchronous update, so let's keep it as a field and call forceUpdate whenever it changes
    _rawValue = '';

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this._toNumber(this._rawValue, null, this.props) !== nextProps.value || this.props.percentage !== nextProps.percentage) {
            this._rawValue = this._toString(nextProps.value, '', nextProps);
            this.forceUpdate();
        }
    }

    _applyMaximumFractionDigits(parsedValue, props = this.props) {
        return typeof props.maximumFractionDigits === 'number' ? roundTo(parsedValue, props.maximumFractionDigits) : parsedValue;
    }

    _toString(parsedValue, fallbackRawValue = '', props = this.props) {
        const formatter = Intl.NumberFormat('fi-FI');
        return parsedValue === null ? '' : isNaN(parsedValue) ? fallbackRawValue : formatter.format(props.percentage ? parsedValue * 100 : parsedValue, props);
    }

    _toNumber(rawValue, fallbackParsedValue = NaN, props = this.props) {
        if (!rawValue) { return null; }

        const parsedValue = +rawValue.replace(/,/g, '.').replace(/\s/g, '');
        return isNaN(parsedValue) ? fallbackParsedValue : this._applyMaximumFractionDigits(parsedValue, props) / (props.percentage ? 100 : 1);
    }

    _onChange = (sender, rawValue) => {
        const
            parsedValue = this._toNumber(rawValue, NaN),
            needsUpdate = this._rawValue !== rawValue;

        this._rawValue = rawValue;

        if (!isNaN(parsedValue) && this.props.onChange) {
            this.props.onChange(this, parsedValue);
        }

        if (needsUpdate) {
            this.forceUpdate();
        }
    };

    _finalizeValue = (rawValue, handler) => {
        const
            parsedValue = this._toNumber(rawValue, this.props.value),
            nextRawValue = this._toString(parsedValue),
            needsUpdate = this._rawValue !== nextRawValue;

        this._rawValue = nextRawValue;

        if (this.props.value !== parsedValue && this.props.onChange) {
            this.props.onChange(this, parsedValue);
        }
        if (handler) {
            handler(this, parsedValue);
        }

        if (needsUpdate) {
            this.forceUpdate();
        }
    };

    _onSubmit = (sender, rawValue) => {
        this._finalizeValue(rawValue, this.props.onSubmit);
    };

    _onBlur = (sender, rawValue, event) => {
        this._finalizeValue(rawValue, this.props.onBlur);

        if (event.relatedTarget) {
            const focusEvent = new FocusEvent('focus', { relatedTarget: event.currentTarget });
            event.relatedTarget.dispatchEvent(focusEvent);
        }
    };

    render() {
        return (
            <TextInput {...this.props} ref="text-input" className={`number-input ${this.props.className}`} value={this._rawValue}
                onChange={this._onChange} onSubmit={this._onSubmit}
                onBlur={this._onBlur} />
        );
    }
}
